import axios from "axios";

const baseURL =
  !process.env.REACT_APP_BASE_URL ||
  process.env.REACT_APP_BASE_URL === "localhost"
    ? window.location.origin
    : process.env.REACT_APP_BASE_URL;

const baseApiURL = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;

const axiosInstance = axios.create({
  baseURL: baseApiURL + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let refreshTokenSubscribers = [];

export const refreshAuthToken = async () => {
  try {
    const response = await axiosInstance.post("/user/signin-by-refresh-token", {
      refreshToken: localStorage.getItem("refreshToken"),
    });

    const { accessToken, refreshToken, user } = response.data;

    localStorage.setItem("userId", JSON.stringify(user).userId);
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("loginUser", JSON.stringify(user));

    refreshTokenSubscribers.forEach((callback) => callback(accessToken));
    refreshTokenSubscribers = [];

    return accessToken;
  } catch (error) {
    console.error("Refresh token failed:", error);
    throw error;
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      error.response.request.responseURL.includes(
        "/api/user/signin-by-refresh-token"
      )
    ) {
      localStorage.removeItem("userId");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      // window.location.reload();
    }

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshTokenSubscribers.push((newAccessToken) => {
            originalRequest.headers["Authorization"] =
              "Bearer " + newAccessToken;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const newAccessToken = await refreshAuthToken();
        originalRequest.headers["Authorization"] = "Bearer " + newAccessToken;
        return axiosInstance(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export const api = async (apiConfig) => {
  try {
    const newConfig = {
      method: apiConfig.method,
      url: apiConfig.url,
    };

    if (apiConfig?.data) newConfig.data = apiConfig.data;
    if (apiConfig?.params) newConfig.params = apiConfig.params;
    if (apiConfig?.baseURL) newConfig.baseURL = apiConfig.baseURL;
    if (apiConfig?.headers) newConfig.headers = apiConfig.headers;
    if (apiConfig?.responseType)
      newConfig.responseType = apiConfig.responseType;

    const response = await axiosInstance(newConfig);
    return response.data;
  } catch (error) {
    throw error.response || error;
  }
};
